<template>
  <b-nav-item
    v-if="menuitem.SubItems == null"
    v-bind:href="externalLink(menuitem)"
    :to="routerLink(menuitem)"
    :name="'menu_' + menuitem.Name"
    :link-attrs="{ id:menuitem.Key}"
    >{{ menuitem.Name }}</b-nav-item
  >
  <b-nav-item-dropdown
    v-else-if="menuitem.SubItems != null"
    :text="menuitem.Name"
    :name="'menu_' + menuitem.Name"
    :id="'menu_' + menuitem.Name"
  >
    <b-dropdown-item
      v-for="item in menuitem.SubItems"
      v-bind:key="item.Link"
      :href="externalLink(item)"
      :to="routerLink(item)"
      :name="'menu_' + menuitem.Name + '_' + item.Name"
      :id="item.Key"
      >{{ item.Name }}</b-dropdown-item
    >
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItem, BNavItemDropdown, BDropdownItem } from 'bootstrap-vue';
export default {
  components: {
    BNavItem,
    BNavItemDropdown,
    BDropdownItem,
  },
  name: 'MainMenuItem',
  props: {
    menuitem: Object,
    useInternalRoutes: Boolean,
  },
  methods: {
    externalLink: function(linkItem) {
      if (this.useInternalRoutes && !linkItem.Link.startsWith('http'))
        return '#';

      return linkItem.Link;
    },
    routerLink: function(linkItem) {
      if (!this.useInternalRoutes || linkItem.Link.startsWith('http'))
        return null;

      return linkItem.Link;
    },
  },
};
</script>

<style>
.nav-link {
  color: #3D4763;
}
</style>
